import { mensagemDeErro } from '@common/errors/mensagemDeErro';
import { Alert, EmptyState, PageHeader, Skeleton } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { useCampanhaAtiva } from '../hooks';

/** `/responder`: leva à campanha ativa (R26). */
export function ResponderPage() {
  const { t } = useTranslation(['formulario', 'erros', 'common']);
  const { data, isLoading, error } = useCampanhaAtiva();

  if (isLoading) return <Skeleton className="h-24 w-full max-w-2xl" />;
  if (error) return <Alert variant="danger" title={t(`erros:${mensagemDeErro(error)}`)} />;
  if (data) return <Navigate to={`/responder/${data.id}`} replace />;
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t('common:nav.responder')} />
      <EmptyState align="start" title={t('formulario:semCampanha')} />
    </div>
  );
}
